export default function PectovoltWebsite() {
  const services = [
    {
      title: "Electrical Engineering",
      desc: "Professional electrical installation, power distribution, troubleshooting, maintenance, and technical support for residential, commercial, and industrial projects.",
      icon: "⚡",
    },
    {
      title: "Renewable Energy",
      desc: "Solar PV design, installation, hybrid systems, backup power integration, and energy efficiency solutions built for reliability.",
      icon: "☀️",
    },
    {
      title: "Construction",
      desc: "Building works, site supervision, infrastructure support, and practical execution with quality and safety at the center.",
      icon: "🏗️",
    },
    {
      title: "Plumbing",
      desc: "Water system installation, piping, drainage works, fittings, repairs, and maintenance for homes and businesses.",
      icon: "🚿",
    },
    {
      title: "Mechanical Services",
      desc: "Machine installation, repair, servicing, and mechanical systems support for workshops, facilities, and project sites.",
      icon: "⚙️",
    },
  ];

  const highlights = [
    "Reliable and timely project delivery",
    "Skilled multidisciplinary technical team",
    "Safe, quality-focused workmanship",
    "Solutions for residential, commercial, and industrial clients",
  ];

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body {
          margin: 0;
          font-family: Arial, Helvetica, sans-serif;
          color: #0f172a;
          background: #ffffff;
        }
        a { text-decoration: none; color: inherit; }
        .container {
          width: min(1120px, calc(100% - 32px));
          margin: 0 auto;
        }
        .site-header {
          position: sticky;
          top: 0;
          z-index: 50;
          background: rgba(7, 24, 52, 0.95);
          color: white;
          border-bottom: 1px solid rgba(255,255,255,0.08);
          backdrop-filter: blur(6px);
        }
        .nav-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 18px 0;
        }
        .brand h1 {
          margin: 0;
          font-size: 28px;
          line-height: 1.1;
        }
        .brand p {
          margin: 4px 0 0;
          color: #cbd5e1;
          font-size: 14px;
        }
        .nav {
          display: flex;
          gap: 22px;
          font-weight: 700;
          color: #e2e8f0;
          flex-wrap: wrap;
        }
        .nav a:hover { color: #f59e0b; }

        .hero {
          background: linear-gradient(135deg, #081528 0%, #0d2c57 55%, #102a43 100%);
          color: white;
          padding: 84px 0 70px;
        }
        .hero-grid {
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 32px;
          align-items: center;
        }
        .eyebrow {
          display: inline-block;
          background: rgba(245, 158, 11, 0.14);
          color: #fcd34d;
          border: 1px solid rgba(245,158,11,0.35);
          padding: 10px 14px;
          border-radius: 999px;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.04em;
          margin-bottom: 16px;
        }
        .hero h2 {
          margin: 0;
          font-size: 54px;
          line-height: 1.05;
          max-width: 760px;
        }
        .hero p {
          color: #dbeafe;
          font-size: 18px;
          line-height: 1.8;
          max-width: 720px;
          margin-top: 18px;
        }
        .cta-row {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          margin-top: 28px;
        }
        .btn {
          display: inline-block;
          padding: 14px 22px;
          border-radius: 14px;
          font-weight: 700;
          transition: transform 0.15s ease, opacity 0.15s ease;
        }
        .btn:hover { transform: translateY(-2px); }
        .btn-primary {
          background: #f97316;
          color: white;
          box-shadow: 0 12px 30px rgba(249, 115, 22, 0.25);
        }
        .btn-secondary {
          border: 1px solid rgba(255,255,255,0.2);
          color: white;
          background: rgba(255,255,255,0.06);
        }
        .hero-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }
        .glass-card, .accent-card {
          border-radius: 24px;
          padding: 22px;
          min-height: 150px;
        }
        .glass-card {
          background: rgba(255,255,255,0.09);
          border: 1px solid rgba(255,255,255,0.12);
          box-shadow: 0 18px 40px rgba(0,0,0,0.18);
        }
        .accent-card {
          background: linear-gradient(135deg, #f97316, #fb923c);
          color: white;
          box-shadow: 0 18px 40px rgba(249,115,22,0.28);
        }
        .card-emoji {
          font-size: 34px;
          line-height: 1;
        }
        .hero-cards h3 {
          margin: 14px 0 8px;
          font-size: 22px;
        }
        .hero-cards p {
          margin: 0;
          font-size: 14px;
          line-height: 1.7;
          color: inherit;
        }

        .section {
          padding: 78px 0;
        }
        .section-title {
          margin: 0 0 14px;
          font-size: 40px;
          line-height: 1.1;
          color: #0f172a;
        }
        .section-subtitle {
          color: #475569;
          font-size: 17px;
          line-height: 1.8;
          max-width: 760px;
          margin: 0 auto 0 0;
        }
        .label {
          color: #ea580c;
          text-transform: uppercase;
          font-weight: 800;
          letter-spacing: 0.14em;
          font-size: 12px;
          margin-bottom: 12px;
        }

        .about-grid {
          display: grid;
          grid-template-columns: 1.1fr 0.9fr;
          gap: 28px;
          align-items: start;
        }
        .about-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 26px;
          padding: 28px;
          box-shadow: 0 10px 30px rgba(15,23,42,0.05);
        }
        .highlight-list {
          display: grid;
          gap: 14px;
          margin-top: 20px;
        }
        .highlight-item {
          display: flex;
          gap: 12px;
          align-items: start;
          background: white;
          border-radius: 18px;
          padding: 16px;
          border: 1px solid #e2e8f0;
        }
        .check {
          width: 34px;
          height: 34px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 999px;
          background: #dbeafe;
          color: #0f3f82;
          font-weight: 800;
          flex: 0 0 auto;
        }

        .services {
          background: #f8fafc;
        }
        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-top: 28px;
        }
        .service-card {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 24px;
          padding: 24px;
          box-shadow: 0 10px 24px rgba(15,23,42,0.05);
          transition: transform 0.15s ease, box-shadow 0.15s ease;
        }
        .service-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 18px 36px rgba(15,23,42,0.10);
        }
        .service-icon {
          font-size: 34px;
          margin-bottom: 12px;
        }
        .service-card h3 {
          margin: 0 0 10px;
          font-size: 24px;
          color: #0f172a;
        }
        .service-card p {
          margin: 0;
          color: #475569;
          line-height: 1.8;
          font-size: 15px;
        }

        .promise {
          background: linear-gradient(135deg, #0f172a, #1e3a5f);
          color: white;
        }
        .promise-wrap {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
          align-items: center;
        }
        .promise .section-title,
        .promise .section-subtitle { color: white; }
        .promise .section-subtitle { color: #cbd5e1; }
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }
        .stat {
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 22px;
          padding: 22px;
        }
        .stat-number {
          font-size: 24px;
          font-weight: 800;
          margin-bottom: 10px;
        }
        .stat p { margin: 0; color: #dbeafe; line-height: 1.7; }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 18px;
          margin-top: 28px;
        }
        .contact-card {
          border: 1px solid #e2e8f0;
          border-radius: 22px;
          padding: 22px;
          background: white;
          box-shadow: 0 10px 24px rgba(15,23,42,0.05);
        }
        .contact-card small {
          display: block;
          color: #64748b;
          margin-bottom: 10px;
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }
        .contact-card strong {
          font-size: 20px;
          color: #0f172a;
        }

        .footer {
          background: #0f172a;
          color: #cbd5e1;
          border-top: 1px solid rgba(255,255,255,0.06);
        }
        .footer-wrap {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          padding: 22px 0;
          flex-wrap: wrap;
        }
        .footer strong { color: white; }

        @media (max-width: 980px) {
          .hero-grid,
          .about-grid,
          .promise-wrap {
            grid-template-columns: 1fr;
          }
          .services-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .contact-grid {
            grid-template-columns: 1fr;
          }
        }
        @media (max-width: 720px) {
          .nav { display: none; }
          .hero { padding: 66px 0 52px; }
          .hero h2 { font-size: 38px; }
          .section-title { font-size: 30px; }
          .services-grid,
          .hero-cards,
          .stats-grid {
            grid-template-columns: 1fr;
          }
          .brand h1 { font-size: 22px; }
        }
      `}</style>

      <div>
        <header className="site-header">
          <div className="container nav-wrap">
            <div className="brand">
              <img
                src="/logo.png"
                alt="Pectovolt Logo"
                style={{ height: "180px" }}
              />
              <p>Electrical • Energy • Construction • Plumbing • Mechanical</p>
            </div>
            <nav className="nav">
              <a href="#about">About us</a>
              <a href="#services">Services</a>
              <a href="#why">Why Us</a>
              <a href="#contact">Contact us</a>
            </nav>
          </div>
        </header>

        <section className="hero">
          <div className="container hero-grid">
            <div>
              <div className="eyebrow">Complete Engineering Solutions</div>
              <h2>
                Professional technical services for modern projects and growing
                businesses.
              </h2>
              <p>
                Mixvolts eng. Ltd provides reliable electrical engineering,
                renewable energy, construction, plumbing, and mechanical
                services for residential, commercial, and industrial clients in
                Rwanda.
              </p>
              <div className="cta-row">
                <a className="btn btn-primary" href="#contact">
                  Request a Quote
                </a>

                <a className="btn btn-secondary" href="#services">
                  View Services
                </a>

                <a
                  href="https://wa.me/250788868255"
                  target="_blank"
                  className="btn btn-primary"
                >
                  Chat on WhatsApp
                </a>
              </div>
            </div>

            <div className="hero-cards">
              <div className="glass-card">
                <div className="card-emoji">⚡</div>
                <h3>Power & Installations</h3>
                <p>
                  Electrical systems, solar support, maintenance, and technical
                  service delivery.
                </p>
              </div>
              <div className="glass-card">
                <div className="card-emoji">🚿</div>
                <h3>Water Systems</h3>
                <p>
                  Plumbing works, piping, fittings, repairs, and efficient
                  system installation.
                </p>
              </div>
              <div className="glass-card">
                <div className="card-emoji">⚙️</div>
                <h3>Mechanical Support</h3>
                <p>
                  Machine servicing, repair, system support, and dependable
                  workshop solutions.
                </p>
              </div>
              <div className="accent-card">
                <div className="card-emoji">🏗️</div>
                <h3>Kigali, Rwanda</h3>
                <p>
                  Serving homes, institutions, contractors, and businesses with
                  complete engineering solutions.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="about">
          <div className="container about-grid">
            <div>
              <div className="label">About Us</div>
              <h2 className="section-title">
                A trusted partner for technical and infrastructure services.
              </h2>
              <p className="section-subtitle">
                Mixvolts eng. Ltd is a multidisciplinary engineering
                company specializing in electrical works, renewable energy
                systems, construction, plumbing, and mechanical services. We
                focus on practical execution, reliable delivery, safety, and
                quality.
              </p>
            </div>

            <div className="about-card">
              <h3 style={{ marginTop: 0, fontSize: 26, color: "#0f172a" }}>
                Why clients choose us
              </h3>
              <div className="highlight-list">
                {highlights.map((item) => (
                  <div key={item} className="highlight-item">
                    <div className="check">✓</div>
                    <div
                      style={{
                        lineHeight: 1.7,
                        color: "#334155",
                        fontWeight: 600,
                      }}
                    >
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="section services" id="services">
          <div className="container">
            <div className="label">Our Services</div>
            <h2 className="section-title">
              Integrated services for complete project delivery.
            </h2>
            <p className="section-subtitle">
              From electrical installations to plumbing, construction, solar
              systems, and mechanical support, Pectovolt delivers coordinated
              services that help clients save time and work with one trusted
              team.
            </p>

            <div className="services-grid">
              {services.map((service) => (
                <div className="service-card" key={service.title}>
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section promise" id="why">
          <div className="container promise-wrap">
            <div>
              <div className="label" style={{ color: "#fdba74" }}>
                Our Promise
              </div>
              <h2 className="section-title">
                Quality work, safe delivery, and dependable support.
              </h2>
              <p className="section-subtitle">
                We combine technical skill, field experience, and a
                customer-focused approach to deliver solutions that are
                practical, durable, and professionally executed.
              </p>
            </div>
            <div className="stats-grid">
              <div className="stat">
                <div className="stat-number">01</div>
                <p>
                  Professional standards in engineering, maintenance, and
                  infrastructure support.
                </p>
              </div>
              <div className="stat">
                <div className="stat-number">02</div>
                <p>
                  Flexible solutions for homes, institutions, businesses, and
                  project sites.
                </p>
              </div>
              <div className="stat">
                <div className="stat-number">03</div>
                <p>
                  Strong commitment to safety, workmanship quality, and client
                  satisfaction.
                </p>
              </div>
              <div className="stat">
                <div className="stat-number">04</div>
                <p>
                  One company for electrical, plumbing, construction, renewable
                  energy, and mechanical works.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="contact">
          <div className="container">
            <div className="label">Contact</div>
            <h2 className="section-title">Let’s work on your next project.</h2>
            <p className="section-subtitle">
              Contact Mixvolts eng. Ltd for quotations, project
              discussions, installations, repairs, maintenance, and technical
              support.
            </p>

            <div className="contact-grid">
              <div className="contact-card">
                <small>Phone</small>
                <strong>+250 788 868 255</strong>
              </div>
              <div className="contact-card">
                <small>Email</small>
                <strong>info@voltixengineering.rw</strong>
              </div>
              <div className="contact-card">
                <small>Location</small>
                <strong>Kigali, Rwanda</strong>
              </div>
            </div>
          </div>
        </section>

        <footer className="footer">
          <div className="container footer-wrap">
            <div>
              <strong>Mixvolts eng. Ltd</strong>
              <div style={{ marginTop: 6 }}>
                Electrical • Energy • Construction • Plumbing • Mechanical
              </div>
            </div>
            <div>© 2026 Mixvolts eng. Ltd. All rights reserved.</div>
          </div>
        </footer>
      </div>
    </>
  );
}
